import PropTypes from 'prop-types'

import Helmet from '@s-ui/react-head'
import Layout from '@adv-mt/mt-layout-basic'
import TrackingPageView from '@adv-mt/mt-tracking-page-view'

import LinkFactory from '../../components/LinkFactory/index.js'
import ResponsePageContent from './components/ResponsePageContent/index.js'

const CheckoutResponsePage = ({helmet, pageName, product}) => {
  return (
    <Layout.FullWidth linkFactory={LinkFactory} footerProps={{isSimple: true}}>
      <Layout.Container isFullWidth>
        <ResponsePageContent pageName={pageName} product={product} />
      </Layout.Container>

      <Helmet {...helmet} />
      <TrackingPageView pageName={pageName} products={product} />
    </Layout.FullWidth>
  )
}

CheckoutResponsePage.displayName = 'CheckoutResponsePage'

CheckoutResponsePage.getInitialProps = async ({routeInfo, context: {domain, i18n}}) => {
  const {
    location: {
      pathname: path,
      query: {price, productId, productTitle}
    }
  } = routeInfo

  const {pageName} = await domain.get('get_page_name_page_use_case').execute({path})
  const [seoDataError, {head: helmet} = {}] = await domain
    .get('get_seo_data_use_case')
    .execute({culture: i18n.culture, pageName})

  return {
    helmet,
    pageName,
    product: {
      id: productId,
      price,
      title: productTitle
    },
    seoDataError
  }
}

CheckoutResponsePage.propTypes = {
  helmet: PropTypes.object,
  pageName: PropTypes.string,
  product: PropTypes.shape({
    id: PropTypes.string,
    price: PropTypes.string,
    title: PropTypes.string
  })
}

export default CheckoutResponsePage
